import { RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamRestartEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamRestartEventDTO.validationSchema()
  );

  constructor(readonly data: RoomStreamRestartEventDTORaw) {
    JsonSchemaValidator.assert(RoomStreamRestartEventDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId"],
      properties: {
        roomId,
        streamId
      },
      additionalProperties: false
    };
  }
}

export interface RoomStreamRestartEventDTORaw {
  roomId: RoomId;
  streamId: StreamId;
}
